// comment
import { Typography } from "@mui/material";
import { Box } from "@mui/system";
import { DebugBox, plural } from "@northpowerdev/np-react-utils";
import { mahiBffUrl } from "../../../data/hikoFetch";
import UpdatedGalleryViewer from "../../upload/UpdatedGalleryViewer";

const bffBaseUrl = mahiBffUrl()

/**
 * 
 * @param {object} props E.g. {
 *  assetKey: {string} E.g. POLE1084471
 *  assetDocsDetails: {DocumentMeta[]} Defined in Types.js in np-react-utils library
 *  sx: {object}
 * }
 * @returns JSX
 */
export default function AssetDocsShow({assetKey, assetDocsDetails, sx}) {
    return (
        <Box>
            <Typography variant="body2">We found {assetDocsDetails.length} document{plural(assetDocsDetails.length)}.</Typography>
            <UpdatedGalleryViewer documents={assetDocsDetails} bffBase={bffBaseUrl} />
            <DebugBox title="assetDocsDetails" stringify>{assetDocsDetails}</DebugBox>
        </Box>
    )
}